import { datetimeCovertertolocal } from '../datetime-converter';
import { CHAINAGES_LIST, CHAINAGES_LIST_SUCCESS, CHAINAGES_LIST_ERROR, ASSET_REPORT_LIST, ASSET_REPORT_LIST_SUCCESS, ASSET_REPORT_LIST_ERROR, ASSET_REPORT_DETAILS, ASSET_REPORT_DETAILS_SUCCESS, ASSET_REPORT_DETAILS_ERROR, MAINTENANCE_HISTORY_UPDATE, MAINTENANCE_HISTORY_UPDATE_SUCCESS, MAINTENANCE_HISTORY_UPDATE_ERROR, ASSET_REPORT_MAINTENANCE_LIST, ASSET_REPORT_MAINTENANCE_LIST_SUCCESS, ASSET_REPORT_MAINTENANCE_LIST_ERROR, ADD_ASSET_MAINTENANCE_DETAILS, ADD_ASSET_MAINTENANCE_DETAILS_SUCCESS, ADD_ASSET_MAINTENANCE_DETAILS_ERROR, ADD_ASSET_REPORT, ADD_ASSET_REPORT_SUCCESS, ADD_ASSET_REPORT_ERROR, MAINTENANCE_HISTORY_DETAILS, MAINTENANCE_HISTORY_DETAILS_SUCCESS, MAINTENANCE_HISTORY_DETAILS_ERROR, ASSET_REPORT_UPDATE, ASSET_REPORT_UPDATE_SUCCESS, ASSET_REPORT_UPDATE_ERROR, FILTER_CHAINAGE, DELETE_ASSETS, DELETE_ASSETS_SUCCESS, DELETE_ASSETS_ERROR, DELETE_ASSET_MAINTENANCE, DELETE_ASSET_MAINTENANCE_SUCCESS, DELETE_ASSET_MAINTENANCE_ERROR, ASSET_TYPE_LIST, ASSET_TYPE_LIST_SUCCESS, ASSET_TYPE_LIST_ERROR } from './constants';
import { CHAINAGE_DETAILS, CHAINAGE_DETAILS_SUCCESS, CHAINAGE_DETAILS_ERROR } from './constants';
import { UPDATE_CHAINAGE, UPDATE_CHAINAGE_SUCCESS, UPDATE_CHAINAGE_ERROR } from './constants';

export default function chaingeFilterReducer(state, action) {
	let chainages = [];
	let pagination = {};
	let assets = [];
	let assets_history = [];
	let filterChainage = [] ;
	let assetType = [];

	switch (action.type) {
	case CHAINAGES_LIST:
		return { ...state, loading: true, error: false };

	case CHAINAGES_LIST_SUCCESS:
		if (action.payload) {
			pagination.total = action.payload.total ? action.payload.total : 0;
			pagination.limit = action.payload.limit ? action.payload.limit : 10;
			pagination.skip = action.payload.skip ? action.payload.skip : 0;
			pagination.current = action.page ? action.page : 1;
			pagination.pageSize =  action.pageSize ? action.pageSize : 10;
		}

		if (action.payload && action.payload.data && action.payload.data.length > 0) {
			action.payload.data.map( (item) => {
				let data = {};

				data.id = item.id ? item.id : 0;
				data.pipelineChainage = item.pipelineChainage || item.pipelineChainage === 0 ? item.pipelineChainage : '';
				data.ODMeter = item.ODMeter;
				data.latitude = item.latitude ? parseFloat(item.latitude) : null;
				data.longitude = item.longitude ? parseFloat(item.longitude) : null;
				data.rouMarker = item.rouMarker ? item.rouMarker : '';
				data.terrainClassification = item.terrainClassification ? item.terrainClassification  : '';
				data.vulnerablePoint = item.vulnerablePoint ? item.vulnerablePoint : false;
				data.isSnoozed = item.isSnoozed ? item.isSnoozed : false;
				data.createdAt = item.createdAt ? item.createdAt : null;
				data.updatedAt = item.updatedAt ? item.updatedAt : null;
				data.isPrimary = item.isPrimary ? item.isPrimary : false;
				data.landmarkDescription = item.landmarkDescription ? item.landmarkDescription  : '';

				return chainages.push(data);
			});

			let sortedChainages = chainages.sort(function(a, b) {
				return parseInt(a.pipelineChainage) - parseInt(b.pipelineChainage);
			});

			return { ...state, chainages: sortedChainages, pagination: pagination, loading: false, error: false };
		} else {
			if (action.payload && action.payload.data && action.payload.data.length === 0) {
				return { ...state, chainages: chainages, pagination: pagination, loading: false, error: false };
			} else {
				return { ...state, loading: false, error: true };
			}
		}

	case CHAINAGES_LIST_ERROR:
		return { ...state, loading: false, error: true };

	case CHAINAGE_DETAILS:
		return { ...state, loading: true, error: false };

	case CHAINAGE_DETAILS_SUCCESS:
		return { ...state, details: action.payload, loading: false, error: false };

	case CHAINAGE_DETAILS_ERROR:
		return { ...state, loading: false, error: true };

	case UPDATE_CHAINAGE:
		return { ...state, loading: true, error: false };

	case UPDATE_CHAINAGE_SUCCESS:
		return { ...state, details: action.payload, loading: false };

	case UPDATE_CHAINAGE_ERROR:
		return { ...state, loading: false, error: true };

	case ASSET_REPORT_LIST:
		return { ...state, loading: true, error: false };
	case ASSET_REPORT_LIST_SUCCESS:
		if (action.payload) {
			
			pagination.total = action.payload.total ? action.payload.total : 0;
			pagination.limit = action.payload.limit ? action.payload.limit : 10;
			pagination.skip = action.payload.skip ? action.payload.skip : 0;
			pagination.current = action.page ? action.page : 1;
			pagination.pageSize =  action.pageSize ? action.pageSize : 10;
		}

		if (action.payload && action.payload && action.payload.length > 0) {
			action.payload.map( (item) => {

				let data = {};

				data.id = item.id ? item.id : 0;
				data.name = item.name ? item.name : '';
				data.regioninfoId = item.regioninfoId;
				data.regionInfo = item.regioninfo.regionName;
				data.pipelineChainageId = item.pipelineChainageId;
				data.pipelineChainage = item?.pipelineconfig ? item.pipelineconfig.pipelineChainage + ' (' + item.pipelineconfig.rouMarker + ')': '';
				data.remarks = item?.remarks;
				data.status = item?.status;
				data.attachmentUrls = item?.attachmentUrls;
				data.pipelineId =  item?.pipelineId ;
				data.assettypeId = item && item?.assettype?.id ? item.assettype.id : null; 
				data.assettypeName = item && item?.assettype?.name ?  item?.assettype.name : '';
				return assets.push(data);
			});

			
			return { ...state, assets:assets , pagination: pagination, loading: false, error: false };
		} else {
			if (action.payload && action.payload && action.payload.length === 0) {
				return { ...state, assets:[], pagination: pagination, loading: false, error: false };
			} else {
				return { ...state, loading: false, error: true };
			}
		}
	case ASSET_REPORT_LIST_ERROR:
		return { ...state, loading: false, error: true };
		
	case ASSET_REPORT_DETAILS:
		return { ...state, loading: true };
		
	case ASSET_REPORT_DETAILS_SUCCESS:

		return { ...state, loading: false, details:action.payload, error: false };
	case ASSET_REPORT_DETAILS_ERROR:
		return { ...state, loading: false, error: true };

	case MAINTENANCE_HISTORY_UPDATE:
		return { ...state, loading: false };
	case MAINTENANCE_HISTORY_UPDATE_SUCCESS:
		return { ...state, loading: false, error: false };
	case MAINTENANCE_HISTORY_UPDATE_ERROR:
		return { ...state, loading: false, error: true }; 
	
	case ASSET_REPORT_MAINTENANCE_LIST:
		return { ...state, loading: true, error: false };
	case ASSET_REPORT_MAINTENANCE_LIST_SUCCESS:
		if (action.payload) {
			

			pagination.total = action.total ? action.total : 0;
			pagination.limit = action.limit ? action.limit : 10;
			pagination.skip = action.skip ? action.skip : 0;
			pagination.current = action.page ? action.page : 1;
			pagination.pageSize =  action.pageSize ? action.pageSize : 10;
			
		}

		if (action.payload && action.payload && action.payload.length > 0) {
			action.payload.map( (item) => {
				let data = {};
				const maintenance_time = datetimeCovertertolocal(item ? item.maintenanceDatetime : '<Not Set>');
				const new_maintenance_time = item && item.maintenanceDatetime ? (maintenance_time.localdate + ' ' + maintenance_time.localtime) : '<Not Set>';
				
				data.id = item.id ? item.id : 0;
				data.name = item.name ? item.name : '';
				data.maintenanceDatetime = new_maintenance_time;
				data.assetsId = item.assetsId;
				data.remarks = item.remarks;
				data.status = item.status;
				data.attachmentUrls = item.attachmentUrls;
				data.pipelineId = item.pipelineId;
				data.UTCmaintenance = item.maintenanceDatetime;
				return assets_history.push(data);
			});

			
			return { ...state, assets_history:assets_history , pagination: pagination, loading: false, error: false };
		} else {
			if (action.payload && action.payload && action.payload.length === 0) {
				return { ...state, assets_history : [] , pagination: pagination, loading: false, error: false };
			} else {
				return { ...state , loading: false, error: true };
			}
		}

	case ASSET_REPORT_MAINTENANCE_LIST_ERROR:
		return { ...state, loading: false, error: true };

	
	case  ADD_ASSET_MAINTENANCE_DETAILS:
		return { ...state, loading: false };
	
	case ADD_ASSET_MAINTENANCE_DETAILS_SUCCESS:
		return { ...state, loading: false, error: false };

	case ADD_ASSET_MAINTENANCE_DETAILS_ERROR:
		return { ...state, loading: false, error: true };

	case ADD_ASSET_REPORT:
		return { ...state, loading: false };
	case ADD_ASSET_REPORT_SUCCESS:
		return { ...state, loading: false, error: false };
	case ADD_ASSET_REPORT_ERROR:
		return { ...state, loading: false, error: true };

	case MAINTENANCE_HISTORY_DETAILS:
		return { ...state, loading: true };
		
	case MAINTENANCE_HISTORY_DETAILS_SUCCESS:
		return { ...state, loading: false, details:action.payload, error: false };
	case MAINTENANCE_HISTORY_DETAILS_ERROR:
		return { ...state, loading: false, error: true };

	case ASSET_REPORT_UPDATE:
		return { ...state, loading: false };
	case ASSET_REPORT_UPDATE_SUCCESS:
		return { ...state, loading: false, error: false };
	case ASSET_REPORT_UPDATE_ERROR:
		return { ...state, loading: false, error: true }; 

	case FILTER_CHAINAGE :
		action.chainage && action.chainage.map((item) => {
			
			filterChainage.push({
				value : item.id,
				label : `${item.pipelineChainage} ( ${item.rouMarker} )`
			});
			
		});
		return { ...state, loading : false, error : false, filterChainage :  filterChainage};

	case DELETE_ASSETS:
		return { ...state, loading: false };
	
	case DELETE_ASSETS_SUCCESS:
		return { ...state, loading: false, error: false };
	
	case DELETE_ASSETS_ERROR:
		return { ...state, loading: false, error: true };

	case DELETE_ASSET_MAINTENANCE:
		return { ...state, loading: false };
	case DELETE_ASSET_MAINTENANCE_SUCCESS:
		return { ...state, loading: false, error: false };
	case  DELETE_ASSET_MAINTENANCE_ERROR:
		return { ...state, loading: false, error: true };

	case ASSET_TYPE_LIST:
		return { ...state, loading: true, error: false };
	
	case ASSET_TYPE_LIST_SUCCESS:
		if (action.payload && action.payload && action.payload.length > 0) {
			action.payload.map( (item) => {
				let data = {};
				
				data.id = item.id ? item.id : 0;
				data.name = item.name ? item.name : '';
				return assetType.push(data);
			});
		}
		return { ...state, assetType : assetType, loading: false, error: false };	
	case ASSET_TYPE_LIST_ERROR:
		return { ...state, loading: false, error: true };	





	default: 
		throw Error('Unknown action: ' + action.type);
      
	}
}